import { useMemo } from 'react'
import { useResizeDetector } from 'react-resize-detector'

import breakpoints from '@/assets/themes/breakpoints'

export function useDocumentsGridSize() {
  const { width: documentsWrapperWidth, ref: documentsWrapperRef } = useResizeDetector<HTMLDivElement>()

  const gridSize = useMemo(() => {
    if (!breakpoints.values || !documentsWrapperWidth) return 12
    if (documentsWrapperWidth > breakpoints.values.lg) return 2
    if (documentsWrapperWidth > breakpoints.values.sm) return 3
    if (documentsWrapperWidth > breakpoints.values.mobileLarge) return 4
    if (documentsWrapperWidth > breakpoints.values.mobile) return 6
    return 12
  }, [documentsWrapperWidth])

  return { documentsWrapperRef, gridSize }
}
